import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageService {

  private listeners: { [key: string]: BehaviorSubject<unknown> } = {}

  /**
   * Guarda um dado na memória de longo prazo da aplicação
   * @param key a chave de acesso ao dado
   * @param value o dado a ser guardado
   */
  public set(key: string, value: any): void {
    if (this.listeners[key] instanceof BehaviorSubject) {
      this.listeners[key].next(value);
    }

    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }

    window.localStorage.setItem(key, value);
  }

  /**
   * Obtem um dado da memória de longo prazo da aplicação
   * @param key a chave de acesso do dado
   */
  public get<T>(key: string): T {
    let value: any = window.localStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (e) {}

    return value as T;
  }

  /**
   * Notifica sempre que um dado específico é alterado na memória da aplicação
   * @param key a chave de acesso indicando o dado
   */
  public listen<T>(key: string): Observable<T> {
    if (this.listeners[key] !instanceof BehaviorSubject) {
      this.listeners[key] = new BehaviorSubject(this.get(key));
    }
    return this.listeners[key].asObservable() as Observable<T>;
  }

  /**
   * Remove um dado da memória da aplicação e encerra todas as notificações relacionadas a ele
   * @param key A chave de acesso indicando o dado
   */
  public destroy(key: string) {
    window.localStorage.removeItem(key);
    if (this.listeners[key]) {
      this.listeners[key].complete();
      delete this.listeners[key];
    }
  }

  /**
   * @deprecated
   * Existe apenas para manter a compatibilidade com o service antigo, utilizar o método [listen] no lugar
   */
  public onStore(key: string, handler: (value: any) => void) {
    this.listen(key).subscribe(value => handler(value));
  }

  /**
   * @deprecated
   * Existe apenas para manter a compatibilidade com o service antigo, utilizar o método [set] no lugar
   */
  public store(key: string, value: string) {
    return new Promise(resolve => {
      this.set(key, value)
      resolve(this.get(key));
    });
  }

}
